"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDanger = exports.addSuccess = exports.addWarning = exports.addError = exports.addAlert = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _enviro = _interopRequireDefault(require("enviro"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var add = function add(type, message) {
  var messageOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!_I18n.default.lookup(message) && messageOptions._defaultMessage && _I18n.default.lookup(messageOptions._defaultMessage)) {
    message = messageOptions._defaultMessage;
  }

  if (_I18n.default.lookup(message)) {
    message = _react.default.createElement(_FormattedHTMLMessage.default, {
      message: message,
      options: messageOptions
    });
  } else if (!_enviro.default.deployed()) {
    // eslint-disable-next-line no-console
    console.warn('Alert key not translated: ', message);

    if (messageOptions._defaultMessage) {
      // eslint-disable-next-line no-console
      console.warn('Alert default key not translated: ', messageOptions._defaultMessage);
    }
  }

  for (var _len = arguments.length, alertOptions = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    alertOptions[_key - 3] = arguments[_key];
  }

  _FloatingAlertStore.default.addAlert(Object.assign.apply(Object, [{
    message: message,
    type: type,
    'data-alert-type': type
  }].concat(alertOptions)));
};

var addAlert = function addAlert() {
  return _FloatingAlertStore.default.addAlert.apply(_FloatingAlertStore.default, arguments);
};

exports.addAlert = addAlert;
var addError = (0, _partial.default)(add, 'warning');
exports.addError = addError;
var addWarning = (0, _partial.default)(add, 'warning');
exports.addWarning = addWarning;
var addSuccess = (0, _partial.default)(add, 'success');
exports.addSuccess = addSuccess;
var addDanger = (0, _partial.default)(add, 'danger');
exports.addDanger = addDanger;